import { useQuery } from '@tanstack/react-query';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { QUERY_KEYS } from '@/utils/query-keys';

export interface GetResolution886ReportReviewParams {
	review_id: string;
	company_id: string;
	organization_id: string;
	report_id: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetResolution886ReportReview = (params: GetResolution886ReportReviewParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.review_id, params.report_id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_RESOLUTION_886_REPORT_REVIEW, params],
		queryFn: async () => Service.getReview(params),
		enabled: isEnabled
	});
};
